export * from './besichtigung-delete-request.interface';
export * from './besichtigung-delete-response.interface';
export * from './besichtigung-delete.shapes';
